const translations = {
  title: 'Forms',
  name: 'Name',
  checklist: 'Checklist',
  replies: 'Replies',
  access: 'Access',
  cardsView: 'Cards view (coming soon)',
  requiredAnswersMissing: 'Required answers missing',
  requiredAnswersMissingMessage: 'Check the questions with red tags.',
  successTitle: 'Form answered successfully!',
  successBody: 'Thank you for your answers',
  sentSuccessfully: 'Sent successfully.',
  alreadyRepliedTitle: 'Form already answered',
  alreadyRepliedDescription: 'You cannot answer this form because it was already answered on {{date}}',
  bulkRegistration: 'Bulk registration',
  sendHistory: 'Send history',
  removeConfirm: 'Are you sure you want to remove?',
  removeError: 'An error occurred while deleting!',
  exportToExcel: 'Export to Excel',
  resume: 'Resume',
  share: 'Share',
  sendHistoryMenu: 'Send History',
  logs: 'Logs',
  edit: 'Edit',
  remove: 'Remove',
  sendDate: 'Send date',
  invites: 'Invites',
  replied: 'Replied',
  resend: 'Resend'
}

export default translations
